import { MARKET_BUDGET_TIER_DEFS } from "../../utils/vehicleSearch/vehicleSearchPriceOptions.js";

export { MARKET_BUDGET_TIER_DEFS as BUDGET_OPTION_DEFS };

export const QUIZ_STORAGE_KEY = "automap_buyer_concierge_quiz_v1";

export const QUIZ_SOURCE = "buyer_concierge_quiz";

/** @deprecated Use BUDGET_OPTION_DEFS with localized labels from getQuizUiCopy */
export const BUDGET_OPTIONS = MARKET_BUDGET_TIER_DEFS.map((entry) => ({
  ...entry,
  label: entry.value,
}));

export const CITY_OPTION_VALUES = [
  "Medellín",
  "Envigado",
  "Sabaneta",
  "Itagüí",
  "Bello",
  "Rionegro",
  "Bogotá",
  "Cali",
  "Otra",
];

/** @deprecated Use CITY_OPTION_VALUES with localized labels from getQuizUiCopy */
export const CITY_OPTIONS = CITY_OPTION_VALUES;

export const VEHICLE_TYPE_OPTION_VALUES = [
  "automovil",
  "suv",
  "pickup",
  "familiar",
  "ciudad",
  "trabajo",
  "unsure",
];

/** @deprecated Use VEHICLE_TYPE_OPTION_VALUES with localized labels from getQuizUiCopy */
export const VEHICLE_TYPE_OPTIONS = VEHICLE_TYPE_OPTION_VALUES.map((value) => ({ value, label: value }));

export const USE_CASE_OPTION_VALUES = [
  "familia",
  "trabajo",
  "ciudad",
  "viajes",
  "montana",
  "primera",
  "consumo",
  "reventa",
];

/** @deprecated Use USE_CASE_OPTION_VALUES with localized labels from getQuizUiCopy */
export const USE_CASE_OPTIONS = USE_CASE_OPTION_VALUES.map((value) => ({ value, label: value }));

export const TRANSMISSION_OPTION_VALUES = ["automatico", "mecanico", "cualquiera"];

/** @deprecated Use TRANSMISSION_OPTION_VALUES with localized labels from getQuizUiCopy */
export const TRANSMISSION_OPTIONS = TRANSMISSION_OPTION_VALUES.map((value) => ({ value, label: value }));

export const FUEL_OPTION_VALUES = ["gasolina", "diesel", "hibrido", "electrico", "cualquiera"];

/** @deprecated Use FUEL_OPTION_VALUES with localized labels from getQuizUiCopy */
export const FUEL_OPTIONS = FUEL_OPTION_VALUES.map((value) => ({ value, label: value }));

export const FINANCING_OPTION_VALUES = ["contado", "financiacion", "comparando", "unsure"];

/** Financing paths where loan term (and down payment) apply. */
export const FINANCING_LOAN_OPTION_VALUES = ["financiacion", "comparando"];

/** @deprecated Use FINANCING_OPTION_VALUES with localized labels from getQuizUiCopy */
export const FINANCING_OPTIONS = FINANCING_OPTION_VALUES.map((value) => ({ value, label: value }));

export const LOAN_TERM_OPTION_VALUES = [12, 24, 36, 48, 60, 72, 84];

export const TIMELINE_OPTION_VALUES = ["today", "this_month", "1-3_months", "researching"];

/** @deprecated Use TIMELINE_OPTION_VALUES with localized labels from getQuizUiCopy */
export const TIMELINE_OPTIONS = TIMELINE_OPTION_VALUES.map((value) => ({ value, label: value }));

export const QUIZ_STEPS = [
  { id: "budget", title: "Presupuesto", subtitle: "Opciones según tu presupuesto" },
  { id: "vehicleType", title: "Tipo de vehículo", subtitle: "Elige la categoría que más se acerca" },
  { id: "useCase", title: "Uso principal", subtitle: "Puedes seleccionar más de uno" },
  { id: "drivetrain", title: "Transmisión y combustible", subtitle: "Preferencias técnicas" },
  { id: "financing", title: "Financiación", subtitle: "Sin presión — solo para orientarte" },
  { id: "timeline", title: "Tiempo de compra", subtitle: "¿Cuándo te gustaría decidir?" },
  { id: "contact", title: "Contacto", subtitle: "Solo concesionarios verificados" },
];

export const TRUST_ITEMS = [
  { title: "Concesionarios verificados", text: "Solo dealers con señales de confianza." },
  { title: "Publicaciones confirmadas", text: "Inventario revisado y actualizado." },
  { title: "Comparación de precio", text: "Señales de precio justo frente al mercado." },
  { title: "Contacto por WhatsApp", text: "Puedes comparar antes de escribir." },
];

export const SUMMARY_FIELD_LABELS = {
  budget: "Presupuesto",
  vehicleType: "Tipo de vehículo",
  useCase: "Uso principal",
  financing: "Financiación",
  downPayment: "Cuota inicial",
  loanTerm: "Plazo del crédito",
  timeline: "Tiempo de compra",
  transmission: "Transmisión",
  fuel: "Combustible",
};
